import { Box } from '@mui/material'
import { FC } from 'react'
import { EditButton, ReferenceField, Show, TextField, useRecordContext, useTranslate } from 'react-admin'
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined'
import { PageHeader, pageSx } from '../../components/ui'
import { border } from '../../layout/theme/border'
import { themeColor } from '../../layout/theme/color'
import { CertificateOut } from '../../types/apiRequests'
import { dateFormatter } from '../../utils/dateFormatter'
import { CertificateStatusPill, CertificateValidityPill } from './CertificatePills'
import CertificateForm from './CertificateForm'
import { useCertificateLabels } from './targetSystems'

// Header: breadcrumb, title (hostname, else "Zaken PKI"), pills, municipality and dates.
const CertificateHeader: FC = () => {
  const translate = useTranslate()
  const record = useRecordContext<CertificateOut>()
  const { title } = useCertificateLabels(record)
  if (!record) return null

  return (
    <PageHeader
      crumbs={[{ label: translate('resources.certificates.list'), to: '/certificate' }]}
      leading={(
        <Box
          component="span"
          aria-hidden
          sx={{
            'width': 44,
            'height': 44,
            'flexShrink': 0,
            'display': 'inline-flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            'borderRadius': '11px',
            'bgcolor': themeColor.slate05,
            'border': `${border.thin} solid ${border.light}`,
            'color': themeColor.slate60,
            '& svg': { fontSize: 22 },
          }}
        >
          <WorkspacePremiumOutlinedIcon />
        </Box>
      )}
      title={title}
      badges={<><CertificateStatusPill /><CertificateValidityPill /></>}
      subtitle={
        <>
          <ReferenceField
            source="municipalityId"
            reference="municipality"
            label="resources.certificates.fields.municipality"
            link="show"
          >
            <TextField source="organisatienNaam" />
          </ReferenceField>
          <span>· {translate('resources.certificates.fields.created')} {dateFormatter(record.created, false)}</span>
          <span>· {translate('data.lastUpdated')} {dateFormatter(record.lastModified)}</span>
        </>
      }
      actions={<EditButton variant="contained" label="resources.certificates.edit" />}
    />
  )
}

const CertificateShow: FC = () => (
  <Show component="div" actions={false} title="resources.certificates.show" sx={pageSx}>
    <CertificateHeader />
    <CertificateForm />
  </Show>
)

export default CertificateShow
